import { Tooltip as ChakraTooltip, TooltipRootProps } from '@chakra-ui/react';
import { Tooltip } from 'components/ui/tooltip';
import { ReactElement } from 'react';

export const TooltipWithTouch = ({
  children,
  label,
  positioning,
  hasArrow,
  ...restToolTipProps // removed/not used, as we should go for recipes instead of individual overwrite, where esp. BG color interferes with the arrow
}: ChakraTooltip.ContentProps & {
  label: ReactElement;
  positioning?: TooltipRootProps['positioning'];
  hasArrow?: boolean;
}): ReactElement => {
  return (
    <Tooltip positioning={positioning} content={label} showArrow={hasArrow}>
      {children}
    </Tooltip>
  );
};
